<template>
  <div class="nav nav-tabs" style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap">
    <template v-for="status in statusOptions">
      <v-btn
        :key="status.value"
        small
        depressed
        class="ma-1"
        :outline="status.value != value"
        :color="status.value != value ? 'grey' : 'primary'"
        @click="handleChangeStatus(status.value)"
        >{{ $t(status.label) }}</v-btn
      >
    </template>
  </div>
</template>

<script>
import { ACOMMERCE_STATUS_OPTIONS, STATUS_OPTIONS } from '@/constants/acommerce.js'
export default {
  props: ['value'],
  data() {
    return {
      //   status: [
      //     { label: 'All', value: 'all' },
      //     { label: 'unpaid', value: 'unpaid' },
      //     { label: 'paid', value: 'paid' },
      //     { label: 'ordered', value: 'ordered' },
      //     { label: 'canceled', value: 'canceled' },
      //     // { label: 'ACOMMERCE_NEW', value: 'NEW' },
      //     { label: 'ACOMMERCE_IN_PROGRESS', value: 'IN_PROGRESS' },
      //     { label: 'ACOMMERCE_BACK_ORDERED', value: 'BACK_ORDERED' },
      //     { label: 'ACOMMERCE_COMPLETED', value: 'COMPLETED' },
      //     { label: 'ACOMMERCE_CANCELLED', value: 'CANCELLED' },
      //     { label: 'ACOMMERCE_ERROR', value: 'ERROR' },
      //     { label: 'ACOMMERCE_WAREHOUSE_SUBMITTED', value: 'WAREHOUSE_SUBMITTED' },
      //     { label: 'ACOMMERCE_READY_TO_PICK', value: 'READY_TO_PICK' },
      //     { label: 'ACOMMERCE_QC_CHECKED', value: 'QC_CHECKED' },
      //     { label: 'ACOMMERCE_PACKED', value: 'PACKED' },
      //     { label: 'ACOMMERCE_READY_TO_SHIP', value: 'READY_TO_SHIP' },
      //     { label: 'ACOMMERCE_IN_TRANSIT', value: 'IN_TRANSIT' },
      //     { label: 'ACOMMERCE_OUT_FOR_DELIVER', value: 'OUT_FOR_DELIVER' },
      //     { label: 'ACOMMERCE_REJECTED_BY_CUSTOMER', value: 'REJECTED_BY_CUSTOMER' },
      //     { label: 'ACOMMERCE_FAILED_TO_DELIVER', value: 'FAILED_TO_DELIVER' },
      //     { label: 'ACOMMERCE_DELIVERED', value: 'DELIVERED' },
      //     { label: 'ACOMMERCE_PREPARING_DELIVERY', value: 'PREPARING_DELIVERY' },
      //     { label: 'ACOMMERCE_OUT_FOR_DELIVERY', value: 'OUT_FOR_DELIVERY' },
      //     { label: 'ACOMMERCE_REJECTED', value: 'REJECTED' }
      //   ]
    }
  },
  computed: {
    statusOptions() {
      return [
        { label: 'All', value: 'all' },
        ...STATUS_OPTIONS,
        ...ACOMMERCE_STATUS_OPTIONS.map((status) => ({
          label: `AC ${this.$t(`ACOMMERCE_${status}`)}`,
          value: status
        }))
      ]
    }
  },
  methods: {
    handleChangeStatus(value) {
      this.$emit('onChangeStatus', value)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/NestleFilterOrderStatus.vue